import * as types from './action_types';
import DateMaster from '../utils/date_master';
import PeopleNotificationsService from '../../services/people_notifications_service';

export const peopleNotifications = (quietMode = false) => {
  return async(dispatch) => {
    try {
      if (!quietMode) {
        dispatch({ type: types.PEOPLE_NOTIFICATIONS_RETRIEVING });
      }
      const peopleNotificationsData = await PeopleNotificationsService.peopleNotifications();
      const peopleNotifications = []
      for (let peopleNotification of peopleNotificationsData) {
        peopleNotifications.push({
          slug: peopleNotification.slug,
          deliveryMethod: peopleNotification.delivery_method,
          peopleNotifiableType: peopleNotification.people_notifiable_type,
          peopleNotifiableSlug: peopleNotification.people_notifiable_slug,
          peopleNotifiableId: peopleNotification.people_notifiable_id,
          triggeredByUserName: peopleNotification.triggered_by_user_name,
          triggeredByUserHasActiveSubscription: peopleNotification.triggered_by_user_has_active_subscription,
          readAt: DateMaster.parseUTC(peopleNotification.read_at),
          createdAt: DateMaster.parseUTC(peopleNotification.created_at),
          likedBy: peopleNotification.liked_by
        });
      }
      dispatch({ type: types.PEOPLE_NOTIFICATIONS_RETRIEVED, peopleNotifications });
    } catch(error) {
      dispatch({ type: types.PEOPLE_NOTIFICATIONS_ERROR, error });
    }
  }
}

export const unreadCount = () => {
  return async(dispatch) => {
    try {
      const unreadCountData = await PeopleNotificationsService.unreadCount();
      const unreadPeopleNotificationsCount = unreadCountData.unread_people_notifications_count;
      dispatch({ type: types.PEOPLE_NOTIFICATIONS_UNREAD_COUNT_RETRIEVED, unreadPeopleNotificationsCount });
    } catch(error) {
      dispatch({ type: types.PEOPLE_NOTIFICATIONS_ERROR, error });
    }
  }
}

export const markAsRead = (slug) => {
  return async(dispatch) => {
    try {
      await PeopleNotificationsService.markAsRead(slug);
      dispatch(unreadCount());
      dispatch(peopleNotifications());
    } catch(error) {
      dispatch({ type: types.PEOPLE_NOTIFICATIONS_ERROR, error });
    }
  }
}

export const markAllAsRead = () => {
  return async(dispatch) => {
    try {
      await PeopleNotificationsService.markAllAsRead();
      dispatch(unreadCount());
      dispatch(peopleNotifications());
    } catch(error) {
      dispatch({ type: types.PEOPLE_NOTIFICATIONS_ERROR, error });
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/people_notifications/actions.js